module.exports = __webpack_public_path__ + "static/media/4.558d7f54.png";